<div class="upload-image-component">

  <div class="upload-area-wrapper">

    <!-- Preview -->
    <div class="image-preview-inline" *ngIf="showPreview && imagePreview">
      <img [src]="imagePreview" />
      <button (click)="removeImage()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <!-- Upload area -->
    <div class="upload-area" *ngIf="!hasImage">
      <span class="upload-text">Upload popup image</span>
      <button class="upload-btn" (click)="triggerFileInput()"><i class="fa-solid fa-plus"></i></button>
    </div>

    <!-- Upload button -->
    <button
      *ngIf="hasImage"
      class="upload-submit-btn"
      (click)="uploadImage()"
      [disabled]="!canUpload"
    >
      <i class="fa-solid fa-spinner fa-spin" *ngIf="isUploading"></i>
      <i class="fa-solid fa-cloud-upload-alt" *ngIf="!isUploading"></i>
      {{ isUploading ? 'Uploading...' : 'Upload' }}
    </button>

  </div>

  <!-- Progress -->
  <div class="upload-progress" *ngIf="isUploading">
    <div class="progress-label">Uploading... {{ uploadProgress }}%</div>
    <div class="progress-bar">
      <div class="progress-bar-fill" [style.width.%]="uploadProgress"></div>
    </div>
  </div>

  <input #fileInput type="file" class="d-none" (change)="onFileSelected($event)" />
</div>
